import { PageHeader } from 'antd'
import { useTranslation } from 'react-i18next'

const ActionAdminPageHeader = () => {
  const { t } = useTranslation()
  return <PageHeader ghost={false} title={t('components.pages.actionAdmin.pageHeader.title')} />
}

ActionAdminPageHeader.displayName = 'ActionAdminPageHeader'
export default ActionAdminPageHeader
